<template>
  <div
    style="
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <ul style="display: flex; padding: 10px 10px 0 10px">
      <li
        style="
          flex: 1;
          font-weight: 600;
          font-size: 14px;
          color: rgb(60, 60, 60);
        "
      >
        工资表
      </li>
      <el-button
        type="primary"
        :icon="Plus"
        link
        @click="state.showAdd = true"
        v-if="$judge_auth('103')"
      >
        创建工资表
      </el-button>
      <el-button
        type="primary"
        :icon="Upload"
        link
        @click="onExport"
        v-if="$judge_auth('810')"
        size="large"
        >导出
      </el-button>
    </ul>
    <div class="list-box" style="flex: 1">
      <ul class="list-search">
        <el-space wrap style="flex: 1">
          <el-input
            v-model="state.params.keywords"
            style="width: 200px"
            placeholder="名称、单号"
            clearable
            @clear="
              delete state.params.keywords;
              onLoad();
            "
            @paste.enter="$onKeywordsPaste($event, state.params)"
          ></el-input>
          <el-input
            v-model="state.params.keywords_employee"
            style="width: 200px"
            placeholder="员工姓名、手机号、证件号"
            clearable
            @clear="
              delete state.params.keywords_employee;
              onLoad();
            "
            @paste.enter="
              $onKeywordsPaste($event, state.params, 'keywords_employee')
            "
          ></el-input>
          <div style="display: flex">
            <el-config-provider
              :value-on-clear="null"
              :empty-values="[undefined, null]"
            >
              <el-select
                v-model="state.params.withholding_agent_type"
                class="c-withholdingagent-search-select"
                @change="
                  delete state.withholding_agent_arr;
                  state.showWithholdingAgent = false;
                "
              >
                <el-option label="扣缴义务人" :value="0" />
                <el-option label="供应商" :value="1" />
              </el-select>
            </el-config-provider>
            <div
              class="c-withholdingagent-search-groupbox"
              @click="state.showWithholdingAgent = true"
            >
              <li style="flex: 1; display: flex; column-gap: 5px">
                <template v-if="state.withholding_agent_arr?.length > 0">
                  <div
                    class="c-withholdingagent-search-tag"
                    style="
                      max-width: 200px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ state.withholding_agent_arr[0]?.name }}
                  </div>
                  <el-popover
                    v-if="state.withholding_agent_arr?.length > 1"
                    placement="right"
                    width="auto"
                    popper-style="max-height: 90vh;overflow-y: auto;"
                  >
                    <template #reference>
                      <div class="c-withholdingagent-search-tag" @click.stop="">
                        {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                      </div>
                    </template>
                    <template #default>
                      <div
                        style="
                          display: flex;
                          flex-direction: column;
                          row-gap: 5px;
                          width: fit-content;
                        "
                      >
                        <ul
                          v-for="(item, index) in state.withholding_agent_arr"
                          :key="item"
                          style="
                            white-space: nowrap;
                            background-color: #f0f2f5;
                            color: var(--el-color-info);
                            border-radius: 4px;
                            font-size: 12px;
                            padding: 0 9px;
                            height: 24px;
                            line-height: 24px;
                            display: flex;
                            align-items: center;
                            column-gap: 10px;
                          "
                        >
                          <li>{{ item.name }}</li>
                          <el-icon
                            @click.stop="
                              state.withholding_agent_arr.splice(index, 1)
                            "
                            color="#a2a2a2"
                            style="cursor: pointer"
                            ><CircleClose
                          /></el-icon>
                        </ul>
                      </div>
                    </template>
                  </el-popover>
                </template>
                <text v-else style="color: #a2a2a2">
                  {{
                    "点击选择" +
                    (state.params.withholding_agent_type === 0
                      ? "扣缴义务人"
                      : "供应商")
                  }}
                </text>
              </li>
              <el-icon
                v-if="state.withholding_agent_arr?.length > 0"
                @click.stop="delete state.withholding_agent_arr"
                color="#a2a2a2"
                ><CircleClose
              /></el-icon>
            </div>
          </div>
          <el-select
            v-model="state.params.customer_id"
            placeholder="所属客户"
            style="width: 200px"
          >
            <el-option
              v-for="item in state.customerData"
              :key="item"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadCustomer()">
                刷新
              </el-button>
            </template>
          </el-select>
          <el-date-picker
            v-model="state.params.month"
            type="month"
            format="YYYY年M月"
            value-format="YYYY-MM"
            placeholder="薪资所属期"
            style="width: 200px"
          />
          <el-date-picker
            v-model="state.params.tax_month"
            type="month"
            format="YYYY年M月"
            value-format="YYYY-MM"
            placeholder="税款所属期"
            style="width: 200px"
          />
          <el-select
            v-model="state.params.d_tax_type_id"
            placeholder="报税类型"
            style="width: 200px"
          >
            <el-option
              v-for="item in state.taxTypeData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
            <template #footer>
              <el-button size="small" @click="onLoadTaxType()">
                刷新
              </el-button>
            </template>
          </el-select>
          <el-date-picker
            v-model="state.dates"
            type="daterange"
            range-separator="至"
            start-placeholder="--发放日期--"
            end-placeholder="--发放日期--"
            style="width: 300px"
            value-format="YYYY-MM-DD"
            @change="
              (value) => {
                if (value) state.params.pay_date = value[0] + ' - ' + value[1];
              }
            "
            @clear="
              delete state.dates;
              delete state.params.pay_date;
            "
          />
          <el-tree-select
            v-model="state.params.belonger_id"
            :props="{
              value: 'id',
              label: 'name',
              class: 'belonger-tree-class',
            }"
            placeholder="负责人"
            :data="state.admin_data"
            style="width: 200px"
            default-expand-all
            filterable
            clearable
          >
            <template #default="{ data }">
              <el-icon :size="16" v-if="data.type == 0"><UserFilled /></el-icon>
              <el-icon :size="16" v-else><User /></el-icon>
              <span style="margin-left: 3px">{{ data.name }}</span>
            </template>
          </el-tree-select>
          <el-config-provider
            :value-on-clear="null"
            :empty-values="[undefined, null]"
          >
            <el-select
              v-model="state.params.is_need_re_calc_tax"
              placeholder="是否需重新算税"
              style="width: 200px"
            >
              <el-option label="需要重新算税" :value="1" />
              <el-option label="无需重新算税" :value="0" />
            </el-select>
          </el-config-provider>
          <el-config-provider
            :value-on-clear="null"
            :empty-values="[undefined, null]"
          >
            <el-select
              v-model="state.params.tax_status"
              placeholder="算税状态"
              style="width: 200px"
            >
              <el-option label="未算税" :value="0" />
              <el-option label="部分算税" :value="1" />
              <el-option label="已算税" :value="2" />
            </el-select>
          </el-config-provider>
          <el-dropdown split-button @click="onLoad" type="primary">
            查询
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                  重置
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </el-space>
      </ul>
      <transition-group class="list-table" name="list" tag="div">
        <el-table
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          class="payroll-list-table"
          @sort-change="onSortChange"
          border
        >
          <el-table-column
            width="70"
            type="index"
            label="序号"
            :index="
              (index) =>
                (state.params.page - 1) * state.params.limit + index + 1
            "
            align="center"
            fixed
          >
          </el-table-column>
          <template v-for="(item, index) in state.columns" :key="item">
            <el-table-column
              v-if="item == 'status'"
              label="状态/单号"
              prop="status"
              sortable="status"
              width="140"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  状态/单号
                </div>
              </template>
              <template #default="{ row }">
                <c_tabgroup>
                  <template #top>
                    <text
                      :style="{ color: row.status == 0 ? '#1e90ff' : '#080' }"
                    >
                      {{ row.status == 0 ? "操作中" : "已完成" }}
                    </text>
                    <el-tag
                      type="danger"
                      size="small"
                      title="需重新算税"
                      style="cursor: pointer; margin-left: 5px"
                      v-if="row.is_need_re_calc_tax"
                      >重
                    </el-tag>
                  </template>
                  <template #bottom>
                    <text
                      style="color: #1e90ff"
                      class="text-hover-decoration"
                      :title="row.order_id"
                      @click="$onCopy(row.order_id)"
                    >
                      {{ row.order_id }}
                    </text>
                  </template>
                </c_tabgroup>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'name'"
              prop="name"
              sortable="name"
              label="名称"
              :formatter="
                (row, column, cellValue) =>
                  $tab_Highlinght(cellValue, state.params.keywords)
              "
              :min-width="260"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  名称
                </div>
              </template>
              <template #default="{ row }">
                <div>
                  <span
                    v-if="row.type == 1"
                    style="
                      color: #fff;
                      font-size: 11px;
                      padding: 2px;
                      line-height: 12px;
                      background-color: #1e90ff;
                      border-radius: 2px;
                    "
                    >0申报</span
                  >
                  {{ row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'withholding_agent'"
              label="扣缴义务人/供应商"
              :width="260"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  扣缴义务人/供应商
                </div>
              </template>
              <template #default="{ row }">
                <template
                  v-if="
                    row.withholdingAgentList?.withholdingAgent?.length > 0 ||
                    row.withholdingAgentList?.supplier?.length > 0
                  "
                >
                  <div
                    v-if="
                      row.withholdingAgentList?.withholdingAgent?.length > 0
                    "
                    data-type="扣"
                    style="--dynamic-color: #ffa500"
                    class="withholding-badge"
                  >
                    {{
                      row.withholdingAgentList?.withholdingAgent[0]
                        .withholding_agent_name
                    }}
                    <el-popover width="auto">
                      <template #reference>
                        <span
                          v-if="
                            row.withholdingAgentList?.withholdingAgent?.length >
                            1
                          "
                          style="
                            padding: 5px;
                            border-radius: 5px;
                            background-color: #e2e2e2;
                            font-size: 12px;
                            cursor: pointer;
                          "
                        >
                          &#43;{{
                            row.withholdingAgentList?.withholdingAgent?.length -
                            1 +
                            (row.withholdingAgentList?.supplier?.length||0)
                          }}
                        </span>
                      </template>
                      <div
                        v-for="item in row.withholdingAgentList?.withholdingAgent?.filter(
                          (w, i) => i != 0,
                        )"
                        :key="item"
                        data-type="扣"
                        style="--dynamic-color: #ffa500;margin-bottom: 5px;"
                        class="withholding-badge"
                      >
                        {{ item.withholding_agent_name }}
                      </div>
                      <div
                        v-for="item in row.withholdingAgentList?.supplier"
                        :key="item"
                        data-type="供"
                        style="--dynamic-color: #1e90ff;margin-bottom: 5px;"
                        class="withholding-badge"
                      >
                        {{ item.withholding_agent_name }}
                      </div>
                    </el-popover>
                  </div>
                  <div
                    v-else
                    data-type="供"
                    style="--dynamic-color: #1e90ff"
                    class="withholding-badge flex"
                  >
                    {{
                      row.withholdingAgentList?.supplier[0]
                        .withholding_agent_name
                    }}
                    <el-popover width="auto">
                      <template #reference>
                        <span
                          v-if="
                            row.withholdingAgentList?.withholdingAgent?.length >
                            1
                          "
                          style="
                            padding: 5px;
                            border-radius: 5px;
                            background-color: #e2e2e2;
                            font-size: 12px;
                            cursor: pointer;
                          "
                        >
                          &#43;{{
                            row.withholdingAgentList?.supplier?.length - 1
                          }}
                        </span>
                      </template>
                      <div
                        v-for="item in row.withholdingAgentList?.supplier?.filter(
                          (w, i) => i != 0,
                        )"
                        :key="item"
                        data-type="供"
                        style="--dynamic-color: #1e90ff;margin-bottom: 5px;"
                        class="withholding-badge"
                      >
                        {{ item.withholding_agent_name }}
                      </div>
                    </el-popover>
                  </div>

                  <!-- <div
                    v-for="item in row.withholdingAgentList?.withholdingAgent"
                    :key="item"
                    data-type="扣"
                    style="--dynamic-color: #ffa500"
                    class="withholding-badge"
                  >
                    {{ item.withholding_agent_name }}
                  </div>
                  <div
                    v-for="item in row.withholdingAgentList?.supplier"
                    :key="item"
                    data-type="供"
                    style="--dynamic-color: #1e90ff"
                    class="withholding-badge"
                  >
                    {{ item.withholding_agent_name }}
                  </div> -->
                </template>
                <text v-else>-</text>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'customer_name'"
              prop="customer_name"
              :formatter="$tab_ShowToolTip"
              :min-width="220"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  所属客户
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'd_service_name'"
              prop="d_service_name"
              :formatter="$tab_ShowToolTip"
              :width="120"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  客户服务类型
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'd_tax_type_name'"
              prop="d_tax_type_name"
              label="报税类型"
              :formatter="$tab_ShowToolTip"
              :width="160"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  报税类型
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'month'"
              prop="month"
              label="薪资所属期"
              :formatter="$tab_ShowToolTip"
              :width="120"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  薪资所属期
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'tax_month'"
              prop="tax_month"
              label="税款所属期"
              :formatter="$tab_ShowToolTip"
              :width="120"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  税款所属期
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'pay_date'"
              prop="pay_date"
              label="发放日期"
              :formatter="$tab_ShowToolTip"
              :width="120"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  发放日期
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'employee_num'"
              prop="employee_num"
              label="员工数量"
              :formatter="$tab_NumberFormat"
              align="center"
              :width="120"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  员工数量
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'settle_amount'"
              prop="settle_amount"
              label="结算金额"
              :formatter="$tab_MoneyFormat"
              align="center"
              :width="120"
              fixed="right"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  结算金额
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'pay_amount'"
              label="实发金额"
              align="center"
              :width="100"
              fixed="right"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  实发金额
                </div>
              </template>
              <template #default="{ row }">
                <c_money
                  :value="row.pay_amount"
                  style="margin: 0 auto; color: #080; font-weight: 600"
                ></c_money>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'tax_mode'"
              label="个税金额"
              align="center"
              :width="90"
              fixed="right"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  个税金额
                </div>
              </template>
              <template #default="{ row }">
                <c_money
                  :value="
                    row.tax_mode == 0
                      ? row.personal_income_tax
                      : row.company_income_tax
                  "
                  style="margin: 0 auto; color: #1e90ff; font-weight: 600"
                ></c_money>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'arrearage_amount'"
              prop="arrearage_amount"
              label="欠款"
              :formatter="$tab_PriceFormat"
              align="center"
              :width="120"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  欠款
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'paied_amount'"
              prop="paied_amount"
              label="已发放"
              :formatter="$tab_PriceFormat"
              align="center"
              :width="120"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  已发放
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'belonger_name'"
              prop="belonger_name"
              label="负责人"
              :formatter="
                (row) =>
                  $tab_GroupFormat(
                    row.belonger_name,
                    row.belonger_department_name || '',
                  )
              "
              min-width="160"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  负责人
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="算税人数"
              :width="200"
              v-else-if="item == 'tax_num'"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  算税人数
                </div>
              </template>
              <template #default="{ row }">
                <div
                  style="
                    width: 100%;
                    display: flex;
                    column-gap: 10px;
                    cursor: pointer;
                  "
                >
                  <el-tag
                    type="info"
                    :title="`未算税：${row.uncalc_tax_num}人`"
                    size="small"
                  >
                    {{ row.uncalc_tax_num }}
                  </el-tag>
                  <el-tag
                    type="success"
                    :title="`已算税：${row.calc_tax_num}人`"
                    size="small"
                  >
                    {{ row.calc_tax_num }}
                  </el-tag>
                  <el-tag
                    type="danger"
                    :title="`算税失败：${row.failure_calc_tax_num}人`"
                    size="small"
                  >
                    {{ row.failure_calc_tax_num }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="发薪人数"
              :width="200"
              v-else-if="item == 'payed_num'"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  发薪人数
                </div>
              </template>
              <template #default="{ row }">
                <div
                  style="
                    width: 100%;
                    display: flex;
                    column-gap: 10px;
                    cursor: pointer;
                  "
                >
                  <el-tag
                    type="info"
                    :title="`未发薪：${row.unpayed_num}人`"
                    size="small"
                  >
                    {{ row.unpayed_num }}
                  </el-tag>
                  <el-tag
                    type="primary"
                    :title="`发薪中：${row.paying_num}人`"
                    size="small"
                  >
                    {{ row.paying_num }}
                  </el-tag>
                  <el-tag
                    type="success"
                    :title="`已发薪：${row.payed_num}人`"
                    size="small"
                  >
                    {{ row.payed_num }}
                  </el-tag>
                  <el-tag
                    type="danger"
                    :title="`发放失败：${row.failure_payed_num}人`"
                    size="small"
                  >
                    {{ row.failure_payed_num }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="item == 'add_admin'"
              label="创建信息"
              :formatter="
                (row) =>
                  $tab_GroupFormat(
                    row.add_admin_name + '/' + row.add_department_name,
                    row.create_time || '',
                  )
              "
              min-width="160"
            >
              <template #header>
                <div
                  style="float: left; width: 100%; cursor: pointer"
                  :draggable="true"
                  @dragstart="dragstart(item)"
                  @dragenter="dragenter(item, $event)"
                  @dragend="getDragend"
                >
                  创建信息
                </div>
              </template>
            </el-table-column>
          </template>
          <el-table-column
            label="操作"
            width="100"
            align="center"
            fixed="right"
          >
            <template #default="{ row }">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                "
              >
                <el-button
                  type="primary"
                  link
                  icon="Edit"
                  @click="
                    $store.commit('openMenu', {
                      path: 'PayrollDetail',
                      title: '工资表管理-' + row.order_id,
                      refresh: true,
                      data: {
                        id: row.id,
                      },
                    })
                  "
                  v-if="$judge_auth('104')"
                >
                  管理
                </el-button>
                <el-button
                  type="primary"
                  link
                  icon="View"
                  @click="
                    $store.commit('openMenu', {
                      path: 'PayrollDetail',
                      title: '工资表详情-' + row.order_id,
                      refresh: true,
                      data: {
                        id: row.id,
                      },
                    })
                  "
                  style="margin-left: 0"
                  v-else
                >
                  查看
                </el-button>
                <el-button
                  type="danger"
                  link
                  icon="Delete"
                  @click="onDelete(row.id)"
                  v-if="$judge_auth('106')"
                  style="margin-left: 0"
                >
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <c_page
          :total="state.totalCount"
          :pageIndex="state.params.page"
          :pageSize="state.params.limit"
          @onLoad="
            (page) => {
              state.params.page = page.pageIndex;
              state.params.limit = page.pageSize;
              onLoad();
            }
          "
        />
      </transition-group>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showAdd"
      title="添加工资表"
      @close="state.showAdd = false"
    >
      <c_PayrollInfo @close="onAddConfirm"></c_PayrollInfo>
    </c_popup>
  </transition>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="
        state.showWithholdingAgent && state.params.withholding_agent_type === 0
      "
      title="选择扣缴义务人"
      @close="state.showWithholdingAgent = false"
    >
      <c_WithholdingAgentSelect
        @close="
          (arr) => {
            state.withholding_agent_arr = arr;
            state.showWithholdingAgent = false;
          }
        "
        :selectItems="state.withholding_agent_arr"
      ></c_WithholdingAgentSelect>
    </c_popup>
  </transition>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="
        state.showWithholdingAgent && state.params.withholding_agent_type === 1
      "
      title="选择供应商"
      @close="state.showWithholdingAgent = false"
    >
      <c_SupplierSelect
        @close="
          (arr) => {
            state.withholding_agent_arr = arr;
            state.showWithholdingAgent = false;
          }
        "
        :selectItems="state.withholding_agent_arr"
      ></c_SupplierSelect>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive } from "vue";
import { payroll_list, payroll_delete, payroll_export } from "@/http/payroll";
import { admin_cascader } from "@/utils/qFormat";
import { data_customer_select } from "@/http/data";
import { taxtype_select } from "@/http/dictionary";
import { confirm_func } from "@/utils/qFormat";
import { ElMessage } from "element-plus";
import store from "@/store";

class InitFormData {
  params = {
    limit: 100,
    page: 1,
  };
}
export default {
  setup() {
    const state = reactive({
      ...new InitFormData(),
      columns: [
        "status",
        "name",
        "withholding_agent",
        "customer_name",
        "d_service_name",
        "d_tax_type_name",
        "month",
        "tax_month",
        "pay_date",
        "employee_num",
        "settle_amount",
        "pay_amount",
        "tax_mode",
        "arrearage_amount",
        "paied_amount",
        "belonger_name",
        "tax_num",
        "payed_num",
        "add_admin",
        "arrearage_amount",
      ],
    });
    onMounted(() => {
      var payroll_colums = localStorage.getItem("payroll_colums");
      if (payroll_colums) {
        const payroll_colums_arr = JSON.parse(payroll_colums);
        if (payroll_colums_arr.length == state.columns.length) state.columns = payroll_colums_arr;
      }

      onLoadCustomer();
      onLoadTaxType();
      onLoadAdmin();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      payroll_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //获取业务员
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    const onLoadTaxType = () => {
      taxtype_select().then((res) => {
        if (res.status == 200) state.taxTypeData = res.data.data;
      });
    };

    const onDateChange = (value) => {
      if (value && value.length == 2)
        state.params.pay_date = value[0] + " - " + value[1];
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      delete state.withholding_agent_arr;
      onLoad();
    };

    const onAddConfirm = (id) => {
      state.showAdd = false;
      onLoad();
      if (id) {
        store.commit("openMenu", {
          path: "PayrollDetail",
          title: "工资表详情",
          refresh: true,
          data: {
            id,
          },
        });
      }
    };

    //删除
    const onDelete = (id) => {
      confirm_func(payroll_delete, id, onLoad);
    };

    const onExport = () => {
      let params = JSON.parse(JSON.stringify(state.params));
      params.limit = 0;
      payroll_export(params)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1],
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8",
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    const dragstart = (value) => {
      state.oldData = value;
      state.dragStartId = value;
    };
    const dragenter = (value) => {
      state.newData = value;
      state.dragEndId = value;
    };
    const getDragend = () => {
      if (state.oldData !== state.newData) {
        let oldIndex = state.columns.indexOf(state.oldData);
        let newIndex = state.columns.indexOf(state.newData);
        let newItems = [...state.columns];
        // 删除之前DOM节点
        newItems.splice(oldIndex, 1);
        // 在拖拽结束目标位置增加新的DOM节点
        newItems.splice(newIndex, 0, state.oldData);
        // 每次拖拽结束后，将拖拽处理完成的数据，赋值原数组，使DOM视图更新，页面显示拖拽动画
        state.columns = newItems;
        localStorage.setItem("payroll_colums", JSON.stringify(newItems));

        // 每次拖拽结束后调用接口时时保存数据
      }
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
      onLoadCustomer,
      onLoadAdmin,
      onLoadTaxType,
      onDateChange,
      onAddConfirm,
      onExport,
      dragstart,
      dragenter,
      getDragend,
    };
  },
};
</script>
<style scoped>
.num_box {
  border-radius: 3px;
  width: 30px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: #fff;
  cursor: pointer;
}
</style>
<style lang="less">
.payroll-list-table {
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;

  .el-table__body {
    .el-table__cell {
      border-right: none !important;
    }
  }
}
</style>
